export default {
  namespaced: true,
  state: {
    requestId: null,
    variables: {
      keyParameter: '',
      filters: [],
      start: '',
      stop: ''
    }
  },
  mutations: {
    setRequestId: (state, id) => (state.requestId = id),
    setVariables: (state, variables) => Object.assign(state.variables, variables)
  }
}
